import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

const IncompleteIdentifiersChip = ({ incompleteCount, totalCount }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Chip
      label={t('{{incompleteCount}}/{{totalCount}} incompletos', { incompleteCount, totalCount })}
      backgroundColor={theme.colors.warning.surface}
      color={theme.colors.warning.onSurface}
      Icon={WarningIcon}
    />
  )
}

export default IncompleteIdentifiersChip
